module.exports = __webpack_public_path__ + "img/L02.53f1f599.jpg";